import { Amplify } from 'aws-amplify';

// Configuration variables - these would typically be stored in environment variables
// or injected during the build process
const config = {
  Auth: {
    // Amazon Cognito Region
    region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
    
    // Amazon Cognito User Pool ID
    userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-1_xxxxxxxxx',
    
    // Amazon Cognito Web Client ID
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || 'xxxxxxxxxxxxxxxxxxxxxxxxxx',
    
    // Authentication flow type
    authenticationFlowType: 'USER_PASSWORD_AUTH',
  }
};

// Configure Amplify
Amplify.configure(config);

export default config;